import React, { useRef, useState } from 'react'
import emailjs from "@emailjs/browser";


function Career() {
  const form = useRef(null);
  const positionInputRef = useRef(null);
  const [errors, setErrors] = useState({});

  const handleApplyClick = (jobTitle) => {
    if (positionInputRef.current) {
      positionInputRef.current.value = jobTitle;
    }

    if (form.current) {
      form.current.scrollIntoView({ behavior: 'smooth' });
    }

    alert(`You're applying for "${jobTitle}". Please fill out the form below.`);
  };

  const validateForm = () => {
    let newErrors = {};

    const name = form.current["name"].value.trim();
    if (!name) {
      newErrors.name = "Name is required.";
    } else if (!/^[A-Za-z\s]+$/.test(name)) {
      newErrors.name = "Name can only contain letters and spaces.";
    }

    const email = form.current["email"].value.trim();
    if (!email) {
      newErrors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    const subject = form.current["subject"].value.trim();
    if (!subject) {
      newErrors.subject = "Subject is required.";
    }

    const message = form.current["message"].value.trim();
    if (!message) {
      newErrors.message = "Message is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (validateForm()) {
      const now = new Date().toLocaleString();
      const timeInput = form.current.querySelector('input[name="time"]');
      if (timeInput) {
        timeInput.value = now;
      }
      const currentYear = new Date().getFullYear();

      emailjs
      .sendForm(
        "service_u3d9pop",
        "template_lopke4b",
        form.current,
        "rPaKJkBM1s-ZgawMN",
        {
          year: currentYear,
        }
      )
        .then(
          (result) => {
            console.log("✅ Email sent:", result.text);
            alert("Message sent successfully!");
            form.current.reset();
          },
          (error) => {
            console.error("❌ Error:", error.text);
            alert("Failed to send message.");
          }
        );
    }
  };


  return (
    <>
      <section className="inner-banner-wrap" style={{ overflowX: "hidden" }}>
        <div
          className="inner-baner-container"
          style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
        >
          <div className="container">
            <div className="inner-banner-content">
              <h1 className="inner-title">Join Our Career Team</h1>
            </div>
          </div>
        </div>
      </section>

      <div className="career-page-section">
        <div className="container">
          <div className="vacancy-section">
            <div className="section-head text-center">
              <div className="row">
                <div className="col-lg-8 offset-lg-2">
                  <div className="title-divider" />
                  <h2 className="section-title">
                    Become a Part of Our <span className="primary-color">Team</span>
                  </h2>
                  <p>
                    We are always looking for passionate individuals to join our team. If you're a driven, forward-thinking person, we’d love to hear from you. Explore the job opportunities below and apply today!
                  </p>
                </div>
              </div>
            </div>

            <div className="vacancy-container">
              <div className="row">
                <div className="col-lg-8">
                  <div className="vacancy-content-wrap">
                    <div className="row">
                      {/* Vacancy Item 1 */}
                      <div className="col-md-6">
                        <div className="vacancy-content">
                          <span>Full Time / Part Time</span>
                          <h4>Market Supervisor</h4>
                          <p>
                            Are you a leader with experience in managing teams? We are looking for a Market Supervisor to join our dynamic team and drive growth.
                          </p>
                          <button
                            className="outline-round"
                            onClick={() => handleApplyClick("Market Supervisor")}
                          >
                            APPLY NOW
                          </button>
                        </div>
                      </div>
                      {/* Vacancy Item 2 */}
                      <div className="col-md-6">
                        <div className="vacancy-content">
                          <span>Full Time</span>
                          <h4>Software Developer</h4>
                          <p>
                            We're looking for a skilled Software Developer to build and maintain innovative digital solutions. Passionate about code?
                          </p>
                          <button
                            className="outline-round"
                            onClick={() => handleApplyClick("Software Developer")}
                          >
                            APPLY NOW
                          </button>
                        </div>
                      </div>
                      {/* Vacancy Item 3 */}
                      <div className="col-md-6">
                        <div className="vacancy-content">
                          <span>Part Time</span>
                          <h4>Accountant</h4>
                          <p>
                            We are in need of a detail-oriented Accountant to manage financial records. Experience in accounting software and attention to detail are a must.
                          </p>
                          <button
                            className="outline-round"
                            onClick={() => handleApplyClick("Accountant")}
                          >
                            APPLY NOW
                          </button>
                        </div>
                      </div>
                      {/* Vacancy Item 4 */}
                      <div className="col-md-6">
                        <div className="vacancy-content">
                          <span>Full Time / Part Time</span>
                          <h4>Tech Marketing Specialist</h4>
                          <p>
                            Are you passionate about tech and marketing? We're looking for a creative and strategic marketing specialist to help us grow our brand in the tech space.
                          </p>
                          <button
                            className="outline-round"
                            onClick={() => handleApplyClick("Tech Marketing Specialist")}
                          >
                            APPLY NOW
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="vacancy-form">
                    <h3>Join Our Team</h3>
                    <p>
                      At Codenix Infotech, we value talent and passion. Believe — send us your application using the form.
                    </p>
                    <form ref={form} onSubmit={sendEmail} className="contact-from">
                      <p>
                        <input type="text" name="name" placeholder="Your Full Name" required />
                        {errors.name && <span className="error text-danger">{errors.name}</span>}
                      </p>
                      <p>
                        <input type="email" name="email" placeholder="Your Email Address" required />
                        {errors.email && <span className="error text-danger">{errors.email}</span>}
                      </p>
                      <p>
                        <input
                          type="text"
                          name="subject"
                          placeholder="Position You Are Applying For"
                          ref={positionInputRef}
                          required
                        />
                        {errors.subject && <span className="error text-danger">{errors.subject}</span>}
                      </p>
                      <p>
                        <textarea
                          rows={7}
                          name="message"
                          placeholder="Tell us why you're a great fit for this role"
                          required
                        />
                        {errors.message && <span className="error text-danger">{errors.message}</span>}
                      </p>
                      {/* Hidden input for timestamp */}
                      <input type="hidden" name="time" />
                      <p>
                        <input
                          type="submit"
                          name="submit"
                          value="SEND APPLICATION"
                        />
                      </p>
                    </form>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div className="about-service-wrap">
            <div className="section-head">
              <div className="row no-gutters align-items-end">
                <div className="col-lg-6">
                  <div className="title-divider" />
                  <h2 className="section-title">
                    Delivering Exceptional User <span className="primary-color">Experiences</span>
                  </h2>
                </div>
                <div className="col-lg-6">
                  <div className="section-disc">
                    <p>
                      We prioritize building exceptional user experiences that drive customer satisfaction and business growth.
                    </p>
                    <p>
                      With a focus on innovation, teamwork, and continuous learning, we’re committed to creating an environment where great ideas thrive.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="iconbox-container d-flex flex-wrap">
              {/* Icon Box 1 */}
              <div className="iconbox-item-3 d-flex flex-wrap">
                <div className="iconbox-border d-flex align-items-center">
                  <div className="iconbox-icon">
                    <i aria-hidden="true" className="icon icon-medal1" />
                  </div>
                  <div className="iconbox-content">
                    <h4>Award-Winning</h4>
                    <p>We are proud to be recognized for excellence in our industry, consistently delivering top-tier results.</p>
                  </div>
                </div>
              </div>
              {/* Icon Box 2 */}
              <div className="iconbox-item-3 d-flex flex-wrap">
                <div className="iconbox-border d-flex align-items-center">
                  <div className="iconbox-icon">
                    <i aria-hidden="true" className="icon icon-money-bag" />
                  </div>
                  <div className="iconbox-content">
                    <h4>Competitive </h4>
                    <p>We offer attractive compensation and benefits packages to ensure our employees are valued and supported.</p>
                  </div>
                </div>
              </div>
              {/* Icon Box 3 */}
              <div className="iconbox-item-3 d-flex flex-wrap">
                <div className="iconbox-border d-flex align-items-center">
                  <div className="iconbox-icon">
                    <i aria-hidden="true" className="icon icon-chart2" />
                  </div>
                  <div className="iconbox-content">
                    <h4>Career Development</h4>
                    <p>We provide continuous learning opportunities and growth paths to help you build a successful career with us.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Career
